// ** Redux Imports
import {combineReducers} from 'redux';

// ** Reducers Imports
import auth from './auth';
import layout from './layout';
import UI from './UI';
import cart from './cart';
import wallet from './wallet';
import notification from './Notification';

const appReducer = combineReducers({
    auth,
    layout,
    cart,
    wallet,
    UI,
    notification
})

const rootReducer = (state, action) => {
    if (action.type === "LOGOUT") {
        state.auth = undefined;
    }

    return appReducer(state, action);
};


export default rootReducer
